import { render } from "./item-logistics-info.vue?vue&type=template&id=3fea47a2"
import script from "./item-logistics-info.vue?vue&type=script&lang=ts"
export * from "./item-logistics-info.vue?vue&type=script&lang=ts"

import "./item-logistics-info.vue?vue&type=style&index=0&id=3fea47a2&lang=scss"
script.render = render

export default script